import React from 'react';
import PropTypes from 'prop-types';
import InviteArea from './inviteArea';
import LeaderComments from './leaderComments';

const MainInvite = props => {
  let invalidInvite;

  if (props.translations['invalid-invite']) {
    invalidInvite = props.translations['invalid-invite'].replace(
      '%{name}',
      props.invites.user.name,
    );
  }

  return (
    <main className="site-width invite">
      {props.invites.invite ||
      props.invites.invite_v2 ||
      props.invites.invite_userIdBridge ? (
        <InviteArea
          translations={props.translations}
          invites={props.invites}
          emailSubmit={props.emailSubmit}
          displayModal={props.displayModal}
          error={props.error}
          enterPush={props.enterPush}
          spinnerDisplay={props.spinnerDisplay}
          expandTextArea={props.expandTextArea}
          inputAreaHeight={props.inputAreaHeight}
          autoCompleteSubmit={props.autoCompleteSubmit}
          modalOnDisplay={props.modalOnDisplay}
        />
      ) : (
        <div>
          <h1>{invalidInvite}</h1>
        </div>
      )}
      {props.invites.comment &&
        Object.keys(props.invites.comment).length !== 0 && (
          <LeaderComments
            translations={props.translations}
            color={props.invites.program.color}
            firstName={props.invites.user.firstName}
            accountInfo={props.invites.comment.href}
            basePath={props.basePath}
            invites={props.invites}
          />
        )}
    </main>
  );
};

MainInvite.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  invites: PropTypes.shape({
    invite: PropTypes.shape({}),
    invite_v2: PropTypes.shape({}),
    invite_userIdBridge: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      name: PropTypes.string,
    }),
    comment: PropTypes.shape({
      href: PropTypes.string,
    }),
    program: PropTypes.shape({
      color: PropTypes.string,
    }),
  }).isRequired,
  error: PropTypes.string,
  spinnerDisplay: PropTypes.bool,
  inputAreaHeight: PropTypes.string,
  emailSubmit: PropTypes.func,
  displayModal: PropTypes.func,
  enterPush: PropTypes.func,
  expandTextArea: PropTypes.func,
  basePath: PropTypes.string,
  autoCompleteSubmit: PropTypes.func,
  modalOnDisplay: PropTypes.string,
};

MainInvite.defaultProps = {
  error: '',
  spinnerDisplay: false,
  inputAreaHeight: '',
  emailSubmit: () => {},
  displayModal: () => {},
  enterPush: () => {},
  expandTextArea: () => {},
  basePath: '',
  autoCompleteSubmit: () => {},
  modalOnDisplay: '',
};

export default MainInvite;
